import React from 'react'

import { Checkbox, ListItem } from 'material-ui'

class WorkersList extends React.Component {

  getWorkerItem = (worker) =>
    <ListItem key={worker.userId}
      // Here is where the generated inner div's styles are set, marginLeft is set to zero to
      // avoid indentation.
      innerDivStyle={workerItemStyle}
      onTouchTap={() => this.props.onWorkerToggled(worker.userId)}>
      <Checkbox
        style={{ width: 24 }}
        iconStyle={{ fill: '#8c8c8c' }}
        checked={worker.selected}/>
      <span style={{ marginLeft: 8 }}>
        {worker.displayName}
      </span>
    </ListItem>

  getUpperList = () => {
    return this.props.list
      .filter(worker => worker.upperList)
      .map(this.getWorkerItem)
  }

  getBottomList = () => {
    if (this.props.list.every(worker => worker.upperList))
      return null
    const items = this.props.list
      .filter(worker => !worker.upperList)
      .map(this.getWorkerItem)
    return (
      <ListItem primaryText='Other Workers'
        primaryTogglesNestedList={true}
        initiallyOpen={true}
        nestedItems={items} />
    )
  }

  render() {
    return (
      <div>
        { this.getUpperList() }
        { this.getBottomList() }
      </div>
    )
  }

}

const workerItemStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  paddingTop: 4,
  paddingBottom: 4,
  paddingLeft: 0,
  paddingRight: 0,
  marginLeft: 0,
  fontSize: 14
}

export default WorkersList


// WEBPACK FOOTER //
// ./src/schedule/workers/WorkersList.js